export const toLocalISOString = (dateString: string | Date) => {
    const date = new Date(dateString);
    const offset = date.getTimezoneOffset();
    const adjustedDate = new Date(date.getTime() - (offset * 60000));
    return adjustedDate.toISOString().slice(0, 16);
};